<!--
  ~ Copyright (C) Motorola Solutions, INC.
  ~ All Rights Reserved.
  -->

<msi-modal *ngLet='service.firmwareUpdateStatus$ | async as firmwareUpdateStatus'>
    <msi-modal-header>
        <h5>
            {{ mode() === FirmwareUpgradeMode.AUTOMATIC ? 'Automatic' : mode() === FirmwareUpgradeMode.PROMPTED ? 'Detected' : '' }}
            {{ service.service.DEVICE_NAME }} Firmware Update
        </h5>
        <button id="firmware-update-close" class="msi-btn msi-btn-icon" (click)="closeWindow()" *ngIf="mode() !== FirmwareUpgradeMode.AUTOMATIC && !firmwareUpdateStatus">
            <msi-icon name="ic_remove" [size]="24"></msi-icon>
        </button>
    </msi-modal-header>
    <msi-modal-content>
        <div *ngIf="mode() === FirmwareUpgradeMode.PROMPTED && !firmwareUpdateStatus">
            <template [ngTemplateOutlet]='hostedFirmwareSelect'></template>
        </div>
        <msi-tab-group id="main-tabs" (selectedIndexChange)="clear()" *ngIf="mode() === FirmwareUpgradeMode.MANUAL && !firmwareUpdateStatus">
            <msi-tab [label]="'Hosted'"><template [ngTemplateOutlet]='hostedFirmwareSelect'></template></msi-tab>
            <msi-tab [label]="'Manual'"><template [ngTemplateOutlet]='manualFirmwareSelect'></template></msi-tab>
        </msi-tab-group>
        <div *ngIf='firmwareUpdateStatus' class='content-wrapper'>
            <div *ngIf="firmwareUpdateStatus.state === 'IN_PROGRESS'">
                <span>Firmware update in progress. Please stand by.</span><br/>
                <span *ngIf='mode() === FirmwareUpgradeMode.AUTOMATIC'>Upon completion the client will reload automatically.</span>
            </div>
            <div *ngIf="firmwareUpdateStatus.state === 'WRITING_FLASH'">Firmware flash in progress. Please stand by.</div>
            <div *ngIf="firmwareUpdateStatus.state === 'SUCCESS'">Firmware update successful.
                <span *ngIf='mode() !== FirmwareUpgradeMode.AUTOMATIC'>Please reload.</span>
            </div>
            <div *ngIf="firmwareUpdateStatus.state === 'FAILED'">Firmware update failed.</div>
            <div *ngIf='firmwareUpdateStatus.msg'>{{firmwareUpdateStatus.msg}}</div>
        </div>
    </msi-modal-content>
    <msi-modal-actions align="end">
        <msi-progress-bar *ngIf="firmwareUpdateStatus" id='firmware-upgrade-progress' [labeled]="true" [value]="firmwareUpdateStatus.progress" [ngClass]="firmwareUpdateStatus.state === 'FAILED' ? 'failed' : ''"></msi-progress-bar>
        <ng-container *ngIf="mode() !== FirmwareUpgradeMode.AUTOMATIC">
            <button *ngIf='!firmwareUpdateStatus' id="update-firmware" class="msi-btn" (click)="doUpdate()" [disabled]='(!selectedFirmware && !selectedFile)'>Firmware update</button>
            <button *ngIf="firmwareUpdateStatus?.state === 'SUCCESS' || firmwareUpdateStatus?.state === 'WRITING_FLASH'" [disabled]=" firmwareUpdateStatus?.state === 'WRITING_FLASH'" id="reload" class="msi-btn" (click)="reload()">Reload</button>
            <button *ngIf="firmwareUpdateStatus?.state === 'IN_PROGRESS'" id="cancel" class="msi-btn" (click)="doCancel()">Cancel</button>
         </ng-container>
    </msi-modal-actions>
</msi-modal>

<ng-template #hostedFirmwareSelect>
    <div class='content-wrapper'>
        <msi-input-group id="firmware-select-input-group">
            <label msiInputLabel for="firmware-select-input-group">Hosted Firmware</label>
            <input msiInput style='display: none'/>
            <msi-select msiInputGroupSelect id="firmware-input-select" [disabled]='mode() !== FirmwareUpgradeMode.MANUAL' [(ngModel)]="selectedFirmware" placeholder="Select Hosted Firmware" (change)="onHostedSelectionChange()">
                <msi-select-option [id]="'firmware-input-option-' + version"
                                   *ngFor="let version of firmware"
                                   [value]="version">{{ version }}
                </msi-select-option>
            </msi-select>
        </msi-input-group>
    </div>
</ng-template>

<ng-template #manualFirmwareSelect>
    <div class='content-wrapper'>
        <msi-input-group id="manual-firmware-select-input-group" *ngIf='selectedFile'>
            <label msiInputLabel for="manual-firmware-select-input-group">Local Firmware</label>
            <input msiInput style='display: none'/>
            <msi-select msiInputGroupSelect id="manual-firmware-input-select" [(ngModel)]="selectedFile" placeholder="Select Local Firmware">
                <msi-select-option [id]="'manual-firmware-input-option'" [value]="selectedFile">{{ selectedFile.name }}</msi-select-option>
            </msi-select>
        </msi-input-group>
        <input id="manual-firmware-file-input" type="file" class="visually-hidden" (change)='onFileSelect($event)'/>
        <label for="manual-firmware-file-input" class='msi-btn' style='width: 100px;'>Select File</label>
    </div>
</ng-template>
